<template>
    <transition name="fade">
        <div class="gs-alert-wrapper" v-show="show">
            <transition name="slide-fade">
                <div class="gs-alert-main" v-show="show">
                    <div class="gs-header-box" v-if="title != ''">{{ title }}</div>
                    <div class="gs-content" v-if="text">{{ text }}</div>
                    <div class="gs-footer-box">
                        <div class="gs-alert-button" @click="handelCancel">
                            {{ cancelText }}
                        </div>
                        <div
                            class="gs-alert-button gs-alert-confirm"
                            @click="handelConfirm"
                        >
                            {{ confirmText }}
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>
<script>
export default {
    name: "gsAlert",
    data() {
        return {
            title: "",
            text: "",
            promise: null,
            show: false,
            cancelText: "",
            confirmText: "",
            cancelCallBack: () => {},
            confirmCallBack: () => {},
        };
    },
    methods: {
        init() {
            this.show = true;
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject };
            });
        },
        handelCancel() {
            // 取消
            this.promise.reject();
            // this.cancelCallBack();
            this.destroyVm();
        },
        handelConfirm() {
            // 确定
            this.promise.resolve();
            this.confirmCallBack();
            this.destroyVm();
        },
        destroyVm() {
            // 销毁
            this.show = false;
            setTimeout(() => {
                this.$destroy(true); // 完全销毁一个实例。清理它与其它实例的连接，解绑它的全部指令及事件监听器
                this.$el && this.$el.parentNode.removeChild(this.$el); // 删除dom
            }, 500);
        },
    },
};
</script>
<style lang="scss" scoped>
.gs-alert-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99999;
    background: rgba($color: #000000, $alpha: 0.3);
    .gs-alert-main {
        width: 296px;
        @include Body_Background($Body_Background);
        border-radius: 5px;
        overflow: hidden;
        .gs-header-box {
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 16px;
            @include PageAuthorInformation_NameColor($PageAuthorInformation_NameColor);
            box-sizing: border-box;
        }
        .gs-content {
            padding: 20px 24px;
            line-height: 24px;
            font-size: 16px;
            @include PageTitleBar_color($PageTitleBar_color);
            box-sizing: border-box;
            text-align: center;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            // text-align: right;
            color: #222222;


        }
        .gs-footer-box {
            display: flex;
            height: 48px;
            border-top: 1px solid;
            @include youXi_ExtendItem_BorderColor($youXi_ExtendItem_BorderColor);
            .gs-alert-button {
                height: 48px;
                width: 0;
                flex: 1;
                text-align: center;
                line-height: 48px;
                font-size: 16px;
                @include PageAuthorInformation_TitleColor($PageAuthorInformation_TitleColor);
                border-right: 1px solid;
                @include youXi_ExtendItem_BorderColor($youXi_ExtendItem_BorderColor);
                user-select: none;
                cursor: pointer;
                &:last-of-type {
                    border: none;
                }
                &.gs-alert-confirm {
                    color: #EB413D;
                }
            }
        }
    }
}
</style>